// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","linkContainer":"Footer_linkContainer__jpi4d","link":"Footer_link__yvgti","copyright":"Footer_copyright__Yoh4-"};